<template>
  <div class="nav-footer navbar-bottom">
    <div class="mt-3">
        <p>© QuickTest</p>
        <p class="underline font-bold text-green-500">Built with <img src="@/assets/love.png"> by Perominc Technologies</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      curd: new Date(),
    };
  },
};
</script>

<style scoped>
.nav-footer {
  background : #243057;
  color: white;
  min-height: 25vh;
  line-height: 15px
}

.logo {
  width: 200px;
  margin: 13px;
}
</style>
